import { SagaIterator } from "redux-saga";
import { call, put } from "redux-saga/effects";
import { HttpResponseTypeEnum } from "../core/enumerations/ServerRequestStatusEnum";
import { dashboardRedux } from "../redux/dashboard-redux/DashboardRedux";
import { projectMeetingRedux } from "../redux/dashboard-redux/project-meetings-redux/ProjectMeetingsRedux";
import { reportRedux } from "../redux/help-and-support-redux/reportRedux";
import { setError, setSuccessfull } from "../redux/toaster-redux/ToasterRedux";

export function* getDashboardData(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getDashboardData, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getDashboardDataSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getDashboardDataFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getDashboardDataFailure(error));
    }
}


export function* getAllMyProjectsBasedOnStatus(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllMyProjectsBasedOnStatus, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getAllMyProjectsBasedOnStatusSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getAllMyProjectsBasedOnStatusFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getAllMyProjectsBasedOnStatusFailure(error));
    }
}

export function* getAllMyCollaboratedProjectsBasedOnStatus(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllMyCollaboratedProjectsBasedOnStatus, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getAllMyCollaboratedProjectsBasedOnStatusSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getAllMyCollaboratedProjectsBasedOnStatusFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getAllMyCollaboratedProjectsBasedOnStatusFailure(error));
    }
}

export function* getProjectDetailsById(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getProjectDetailsById, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getProjectDetailsByIdSuccess(response.data));
            // yield put(setSuccessfull(response));
        } else {
            yield put(dashboardRedux.actions.getProjectDetailsByIdFailure(response.data));
            // yield put(setError(response));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getProjectDetailsByIdFailure(error));
    }
}

export function* applyProject(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.applyProject, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.applyProjectSuccess(response.data));
            // yield put(setSuccessfull(response));
        } else {
            yield put(dashboardRedux.actions.applyProjectFailure(response.data));
            // yield put(setError(response));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.applyProjectFailure(error));
    }
}

export function* acceptInvitation(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.acceptInvitation, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.acceptInvitationSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.acceptInvitationFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.acceptInvitationFailure(error));
    }
}


export function* getAllArtistsOfProjectByInviteStatus(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllArtistsOfProjectByInviteStatus, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getAllArtistsOfProjectByInviteStatusSuccess(response.data));
            // yield put(setSuccessfull(response));
        } else {
            yield put(dashboardRedux.actions.getAllArtistsOfProjectByInviteStatusFailure(response.data));
            // yield put(setError(response));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getAllArtistsOfProjectByInviteStatusFailure(error));
    }
}

export function* removeCollaboratorById(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.removeCollaboratorById, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.removeCollaboratorByIdSuccess(response.data));
            // yield put(setSuccessfull(response));
        } else {
            yield put(dashboardRedux.actions.removeCollaboratorByIdFailure(response.data));
            // yield put(setError(response));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.removeCollaboratorByIdFailure(error));
    }
}


export function* getCollaboratorNegotiationDetails(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getCollaboratorNegotiationDetails, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getCollaboratorNegotiationDetailsSuccess(response.data));
            // yield put(setSuccessfull(response));
        } else {
            yield put(dashboardRedux.actions.getCollaboratorNegotiationDetailsFailure(response.data));
            // yield put(setError(response));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getCollaboratorNegotiationDetailsFailure(error));
    }
}


export function* acceptOrDeclineCollaborationRequest(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.acceptOrDeclineCollaborationRequest, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.acceptOrDeclineCollaborationSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.acceptOrDeclineCollaborationFailure(response.data));
            yield put(setError(response));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.acceptOrDeclineCollaborationFailure(error));
    }
}

export function* rejectProjectInvite(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.rejectProjectInvite, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.rejectProjectInviteSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.rejectProjectInviteFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.rejectProjectInviteFailure(error));
    }
}


export function* inviteCollaborator(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.inviteCollaborator, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.inviteCollaboratorSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.inviteCollaboratorFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.inviteCollaboratorFailure(error));
    }
}


export function* getAllInvitedCollaborators(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllInvitedCollaborators, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getAllInvitedCollaboratorsSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getAllInvitedCollaboratorsFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getAllInvitedCollaboratorsFailure(error));
    }
}

export function* exitProject(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.exitProject, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.exitProjectSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.exitProjectFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.exitProjectFailure(error));
    }
}


export function* reNegotiation(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.reNegotiation, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.reNegotiationSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.reNegotiationFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.reNegotiationFailure(error));
    }
}

export function* endProject(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.endProject, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.endProjectSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.endProjectFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.endProjectFailure(error));
    }
}

export function* rateProject(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.rateAllProjectMembers, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.rateProjectSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.rateProjectFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.rateProjectFailure(error));
    }
}

export function* fetchProjectContractSaga(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.fetchProjectContract, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.Accepted
        ) {
            yield put(dashboardRedux.actions.getProjectContractSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getProjectContractFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getProjectContractFailure(error));
    }
}

export function* getAllCollaborators(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllCollaborators, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getAllCollaboratorsSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getAllCollaboratorsFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getAllCollaboratorsFailure(error));
    }
}

export function* getAllProjectMembers(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllProjectMembers, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getAllProjectMembersSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getAllProjectMembersFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getAllProjectMembersFailure(error));
    }
}

export function* deleteProject(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.deleteProject, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.deleteProjectSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.deleteProjectFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.deleteProjectFailure(error));
    }
}

export function* getProjectMedias(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getProjectMedias, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getProjectMediasSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getProjectMediasFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getProjectMediasFailure(error));
    }
}

// Tasks

export function* getProjectTasks(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getProjectTasks, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getProjectTasksSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getProjectTasksFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getProjectTasksFailure(error));
    }
}

export function* getAllProjectTasks(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllProjectTasks, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getAllProjectTasksSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getAllProjectTasksFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getAllProjectTasksFailure(error));
    }
}

export function* createProjectTask(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.createProjectTask, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.createProjectTaskSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.createProjectTaskFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.createProjectTaskFailure(error));
    }
}

export function* getAllAssigneesByTaskId(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllAssigneesByTaskId, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getAllAssigneesByTaskIdSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getAllAssigneesByTaskIdFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getAllAssigneesByTaskIdFailure(error));
    }
}

export function* getAllUnassignedArtistsByTaskId(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllUnassignedArtistsByTaskId, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getAllUnassignedArtistsByTaskIdSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getAllUnassignedArtistsByTaskIdFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getAllUnassignedArtistsByTaskIdFailure(error));
    }
}

export function* removeAssignedArtists(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.removeAssignedArtists, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.removeAssignedArtistsSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.removeAssignedArtistsFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.removeAssignedArtistsFailure(error));
    }
}

export function* updateTaskById(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.updateTaskById, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.updateTaskByIdSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.updateTaskByIdFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.updateTaskByIdFailure(error));
    }
}

export function* deleteTask(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.deleteTask, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.deleteTaskSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.deleteTaskFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.deleteTaskFailure(error));
    }
}


export function* getTaskDetailsById(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getTaskDetailsById, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.getTaskDetailsByIdSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.getTaskDetailsByIdFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.getTaskDetailsByIdFailure(error));
    }
}

export function* selfTaskAssignment(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.selfTaskAssignment, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.selfTaskAssignmentSuccess(response.data));
        } else {
            yield put(dashboardRedux.actions.selfTaskAssignmentFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.selfTaskAssignmentFailure(error));
    }
}

//project meetings

export function* getAllMeetings(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllMeetings, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(projectMeetingRedux.actions.getAllProjectMeetingsSuccess(response.data));
        } else {
            yield put(projectMeetingRedux.actions.getAllProjectMeetingsFailure(response.data));
        }
    } catch (error: any) {
        yield put(projectMeetingRedux.actions.getAllProjectMeetingsFailure(error));
    }
}

export function* getAllMeetingsById(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllMeetingsById, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(projectMeetingRedux.actions.getProjectMeetingsSuccess(response.data));
        } else {
            yield put(projectMeetingRedux.actions.getProjectMeetingsFailure(response.data));
        }
    } catch (error: any) {
        yield put(projectMeetingRedux.actions.getProjectMeetingsFailure(error));
    }
}

export function* createMeeting(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.createMeeting, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(projectMeetingRedux.actions.createProjectMeetingSuccess(response.data));
        } else {
            yield put(projectMeetingRedux.actions.createProjectMeetingFailure(response.data));
        }
    } catch (error: any) {
        yield put(projectMeetingRedux.actions.createProjectMeetingFailure(error));
    }
}


export function* updateMeeting(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.updateMeeting, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(projectMeetingRedux.actions.updateProjectMeetingSuccess(response.data));
        } else {
            yield put(projectMeetingRedux.actions.updateProjectMeetingFailure(response.data));
        }
    } catch (error: any) {
        yield put(projectMeetingRedux.actions.updateProjectMeetingFailure(error));
    }
}


export function* deleteMeeting(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.deleteMeeting, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(projectMeetingRedux.actions.deleteProjectMeetingSuccess(response.data));
        } else {
            yield put(projectMeetingRedux.actions.deleteProjectMeetingFailure(response.data));
        }
    } catch (error: any) {
        yield put(projectMeetingRedux.actions.deleteProjectMeetingFailure(error));
    }
}

//report post
export function* reportPost(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.reportPost, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(reportRedux.actions.reportPostSuccess(response.data));
        } else {
            yield put(reportRedux.actions.reportPostFailure(response.data));
        }
    } catch (error: any) {
        yield put(reportRedux.actions.reportPostFailure(error));
    }
}

//report comment reportComment
export function* reportComment(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.reportComment, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(reportRedux.actions.reportCommentSuccess(response.data));
        } else {
            yield put(reportRedux.actions.reportCommentFailure(response.data));
        }
    } catch (error: any) {
        yield put(reportRedux.actions.reportCommentFailure(error));
    }
}

//report reply reportReply
export function* reportReply(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.reportReply, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(reportRedux.actions.reportReplySuccess(response.data));
        } else {
            yield put(reportRedux.actions.reportReplyFailure(response.data));
        }
    } catch (error: any) {
        yield put(reportRedux.actions.reportReplyFailure(error));
    }
}

//report project
export function* reportProject(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.reportProject, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(reportRedux.actions.reportProjectSuccess(response.data));
        } else {
            yield put(reportRedux.actions.reportProjectFailure(response.data));
        }
    } catch (error: any) {
        yield put(reportRedux.actions.reportProjectFailure(error));
    }
}

//report user
export function* reportUser(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.reportUser, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(reportRedux.actions.reportUserSuccess(response.data));
        } else {
            yield put(reportRedux.actions.reportUserFailure(response.data));
        }
    } catch (error: any) {
        yield put(reportRedux.actions.reportUserFailure(error));
    }
}

//report problem
export function* reportProblem(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.reportProblem, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(reportRedux.actions.reportProblemSuccess(response.data));
            //   yield put(setSuccessfull(response));
        } else {
            yield put(reportRedux.actions.reportProblemFailure(response.data));
        }
    } catch (error: any) {
        yield put(reportRedux.actions.reportProblemFailure(error));
    }
}

//project - view - count
export function* projectViewCountSaga(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getProjectViews, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(dashboardRedux.actions.projectViewCountSuccess(response.data));
            //   yield put(setSuccessfull(response));
        } else {
            yield put(dashboardRedux.actions.projectViewCountFailure(response.data));
        }
    } catch (error: any) {
        yield put(dashboardRedux.actions.projectViewCountFailure(error));
    }
}




